import React from 'react';
import { useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';

import { editContent } from '../../modules/editor';
import useAlert from '../../hooks/useAlert';
import { getPathAfterBuild } from '../../util/file';

type Props = {
	target: string;
	imagePath: string;
	name: string;
	value: string|undefined;
	imageType?: string;
	confirmText?: string;
};

function ButtonToggleValue({ target, value, imagePath, imageType, name, confirmText }: Props) {
	const dispatch = useDispatch();
	const Alert = useAlert();

	const iconImage = (path) => {
		const context = require.context('../../assets/images/', true);
		return getPathAfterBuild(context, path);
	};

	const onClick = (e: any) => {		
		const nextValue = name === value ? '' : name;
		
		if (confirmText) {
			Alert.confirm(confirmText, () => {
				dispatch(editContent({ target: target, data: nextValue }));
			});
		} else {
			dispatch(editContent({ target: target, data: nextValue }));
		}
	}

	const nameFilter = (name:string) => {
		return name.replace('%','');
	}

	return (
		<button
			className={(value && value.includes(name)) ? 'btn active' : 'btn'}
			onClick={onClick}>
			{
				imageType === 'svg' ? (
					<ReactSVG src={iconImage(`./${imagePath}${nameFilter(name)}.${imageType}`)} height="16" />
				) : (
					<img src={iconImage(`./${imagePath}${nameFilter(name)}.${imageType}`)} height="16" />
				)
			}
		</button>
	);
}

ButtonToggleValue.defaultProps = {
	imageType: 'png'
};

export default ButtonToggleValue;